module.exports = __webpack_public_path__ + "static/c_9-c97a219b71a7b1dee31aab256be5e905.jpg";